import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  AccordionSummary,
  Typography,
  IconButton,
  AccordionDetails,
  Accordion,
  InputLabel,
  FormHelperText
} from '@material-ui/core'
import { useStyles } from '../Styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import EditIcon from '@material-ui/icons/Edit'
import FormSelectField from '../../../../FormFields/FormSelectField'
import FormTextField from '../../../../FormFields/FormTextField'
import receiverTypes from '../../../../configurations/receiver-types'
import { concatBranchAddress, concatReceiverBranchAddress } from '../../../../utils/helpers'
import { CreateInvoiceConsumer } from '../../../../context/CreateInvoiceContext'
import { FormLoader } from '../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import countryCodes from '../../../../configurations/country-codes'
import CookiesStorageService from '../../../../Services/CookiesStorageService'
import governates from '../../../../configurations/governates'
import cities from '../../../../configurations/cities'

const Receiver = ({ formClasses, oldData, data, formActions, handleAddressDialog, getReceiverDetails, resetReceiverDetails, currentReceiverDetails, locale, inDialog, hasDrafted, invoicePersonalLimit, isExport }) => {
  const classes = useStyles()
  const [currentReceiverID, setCurrentReceiverID] = React.useState('')
  const [firstTimeDraft, setFirstTimeDraft] = React.useState(!!hasDrafted)
  React.useEffect(() => {
      if ('B' === formActions.values.receiverType && !!formActions.values.receiverID && [9, 10].includes(formActions.values.receiverID?.length) &&
        formActions.values.receiverID?.toString() !== CookiesStorageService.getTaxpayerTRN()?.toString()) {
        setCurrentReceiverID(formActions.values.receiverID)
        getReceiverDetails(formActions.values.receiverID)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [formActions.values.receiverID])

  React.useEffect(() => {
      if (!!formActions.values.receiverBranchID || formActions.values.receiverBranchID?.toString() === '0') {
        getReceiverBranchDetails(formActions.values.receiverBranchID)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [formActions.values.receiverBranchID])

  // React.useEffect(() => {
  //     formActions.setFieldValue('receiverID', '')
  //     formActions.setFieldTouched('receiverID', false, false)
  //
  //     formActions.setFieldValue('receiverName', '')
  //     formActions.setFieldTouched('receiverName', false, false)
  //
  //     formActions.setFieldValue('receiverBranchID', '')
  //     formActions.setFieldTouched('receiverBranchID', false, false)
  //
  //     formActions.setFieldValue('receiverAddress', {})
  //     formActions.setFieldTouched('receiverAddress', false, false)
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [formActions.values.receiverType])

  const getReceiverBranchDetails = (branchNumber) => {
    if (branchNumber !== null) {
      let branch = currentReceiverDetails?.branches?.filter(item => item?.branch_number?.toString() === branchNumber?.toString())
      let branchObj = branch?.length ? branch[0] : {}
      if (!!firstTimeDraft || (branchNumber?.toString() === oldData?.receiverBranchID?.toString())) {
        formActions.setFieldValue('receiverAddress', oldData?.receiverAddress)
        formActions.setFieldTouched('receiverAddress', true, false)
        setFirstTimeDraft(false)
      } else {
        if (!!Object.keys(branchObj || {}).length) {
          let country = countryCodes?.filter(country => country?.key?.toString() === (branchObj.address?.country || 'EG').toString())
          if (!!country?.length) {
            country = country[0]
          }
          let gov = [...governates, ...cities].filter((item) => branchObj.address?.governorate?.toString() === item.code?.toString() || branchObj.address?.governorate?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا') === item[`name_${locale}` || 'name_en']?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا'))
          gov = gov?.length ? gov[0][`name_${locale}` || 'name_en'] : branchObj.address?.governorate

          let city = [...cities, ...governates].filter((item) => branchObj.address?.city?.toString() === item.code?.toString() || branchObj.address?.city?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا') === item[`name_${locale}` || 'name_en']?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا'))
          city = city?.length ? city[0][`name_${locale}` || 'name_en'] : branchObj.address?.city

          let receiverAddress = {
            country: branchObj.address?.country || 'EG',
            countryName: country[`name_${locale}`] || '',
            governate: gov || '',
            regionCity: city || '',
            street: branchObj.address?.street_name || '',
            buildingNumber: branchObj.address?.building_number || '',
            floor: branchObj.address?.floor || '',
            room: branchObj.address?.room || '',
            landmark: branchObj.address?.landmark || '',
            postalCode: branchObj.address?.postal_code || '',
            additionalInformation: branchObj.address.additional_information || ''
          }

          formActions.setFieldValue('receiverAddress', receiverAddress)
          formActions.setFieldTouched('receiverAddress', true, false)
        }
      }
    }
  }

  React.useEffect(() => {
      if (!!currentReceiverDetails) {
        if (!!Object.keys(currentReceiverDetails || {}).length) {
          setTimeout(() => formActions.setFieldTouched('receiverName', true, true), 50)
          formActions.setFieldValue('receiverName', locale === 'ar' ? currentReceiverDetails?.name_ar || currentReceiverDetails?.name || '' : currentReceiverDetails?.name || '')
          if (!!currentReceiverDetails?.branches?.length && !(!!formActions.values.receiverBranchID || formActions.values.receiverBranchID?.toString() === '0')) {
            getReceiverBranchDetails(currentReceiverDetails?.branches[0]?.branch_number)
            formActions.setFieldValue('receiverBranchID', currentReceiverDetails?.branches[0]?.branch_number)
            formActions.setFieldTouched('receiverBranchID', true, false)
          }
        } else {
          formActions.setFieldValue('receiverName', '')
          formActions.setFieldTouched('receiverName', false, false)
          formActions.setFieldValue('receiverBranchID', '')
          formActions.setFieldTouched('receiverBranchID', false, false)
          formActions.setFieldValue('receiverAddress', {})
          formActions.setFieldTouched('receiverAddress', false, false)
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentReceiverDetails])

  React.useEffect(() => {
      if (!!isExport) {
        formActions.setFieldValue('receiverType', 'F')
      } else {
        formActions.setFieldValue('receiverType', oldData?.receiverType || 'B')
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [isExport])

  const receiverAddressCombined = React.useMemo(() => concatBranchAddress(formActions.values.receiverAddress), [formActions.values.receiverAddress])

  return (
    <div className={classes.IssuerReceiverWrapper + (!!inDialog ? ' in-dialog' : '')}>
      <Accordion defaultExpanded={true} elevation={0}>
        {!inDialog &&
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          className={classes.IssuerReceiverHeaderWrapper + ' receiver'}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.IssuerReceiverHeader}>
            <Typography className={classes.ItemHeading}>{data?.icon}{data?.title}</Typography>
          </div>
        </AccordionSummary>
        }
        <CreateInvoiceConsumer>
          {({ currentReceiverDetailsLoading, currentReceiverDetailsFailure }) => (
            <AccordionDetails
              className={classes.IssuerReceiverDetailsWrapper + ' receiver' + (!!inDialog ? ' in-dialog' : '')}>

              {!!inDialog ? <>
                  <Alert severity="error" className={formClasses.alert}>
                    <FormattedMessage id='invoice.step3.personalLimitData.AlertHint'/>
                  </Alert>

                  <FormTextField name={'receiverName'} labelKey={'Fields.label.receiverName'}
                                 classes={formClasses} formActions={formActions} required/>
                </> :
                <FormSelectField name={'receiverType'} labelKey={'Fields.label.receiverType'}
                                 classes={formClasses} locale={locale}
                                 formActions={formActions} required
                                 setFilter={(value) => {
                                   resetReceiverDetails()
                                   formActions.setFieldValue('receiverID', '')
                                   formActions.setFieldTouched('receiverID', false, false)
                                   formActions.setFieldValue('receiverName', '')
                                   formActions.setFieldTouched('receiverName', false, false)
                                   formActions.setFieldValue('receiverBranchID', '')
                                   formActions.setFieldTouched('receiverBranchID', false, false)
                                   formActions.setFieldValue('receiverAddress', {})
                                   formActions.setFieldTouched('receiverAddress', false, false)
                                   if (value === 'B') {
                                     if (!!formActions.values.receiverID && [9, 10].includes(formActions.values.receiverID?.length) && formActions.values.receiverID?.toString() !== CookiesStorageService.getTaxpayerTRN()?.toString()) {
                                       getReceiverDetails(formActions.values.receiverID)
                                     }
                                   }
                                 }}
                                 list={!!isExport ? receiverTypes?.map(type => ({
                                   ...type,
                                   disabled: type.key !== 'F'
                                 })) : receiverTypes}/>
              }
              <FormTextField name={'receiverID'}
                             labelKey={`Fields.label.receiverID.${formActions.values.receiverType}`}
                             classes={formClasses}
                             invalidTRN={'B' === formActions.values.receiverType && (formActions.values.receiverID?.toString() === CookiesStorageService.getTaxpayerTRN()?.toString()) ?
                               <FormattedMessage id='validationSchema.ReceiverTRN'/> : null}
                             formActions={formActions}
                             required={!(formActions.values.receiverType === 'P' && (!invoicePersonalLimit ||
                               parseFloat(formActions.values.itemsAmount) < parseFloat(invoicePersonalLimit)))}/>

              <div className={classes.IssuerReceiverDetailsContainer}>
                {'B' === formActions.values.receiverType && <>
                  {!!currentReceiverDetailsLoading && <FormLoader loading={true}/>}
                  {!!currentReceiverDetailsFailure &&
                  <Alert severity="error" className={formClasses.alert + ' ' + formClasses.hint}>
                    <FormattedMessage id='receiverID.details.AlertHint' values={{
                      strong: chunks => <strong>{chunks}</strong>,
                      receiverID: currentReceiverID
                    }}/>
                  </Alert>
                  }
                </>
                }
                {!inDialog &&
                <FormTextField name={'receiverName'} row disabled={'B' === formActions.values.receiverType}
                               labelKey={'Fields.label.receiverName'} classes={formClasses}
                               formActions={formActions}
                               required={!(formActions.values.receiverType === 'B' || (formActions.values.receiverType === 'P' &&
                                 (!invoicePersonalLimit || parseFloat(formActions.values.itemsAmount) < parseFloat(invoicePersonalLimit))))}/>}

                {'B' === formActions.values.receiverType && !!currentReceiverDetails?.branches?.length &&
                <FormSelectField name={'receiverBranchID'} labelKey={'Fields.label.receiverBranchID'}
                                 classes={formClasses} row withKeyParenthesis
                                 formActions={formActions} required
                                 list={currentReceiverDetails?.branches?.map((branch, index) => ({
                                   ...branch,
                                   key: branch?.branch_number,
                                   returnedName: branch.name,
                                   name: concatReceiverBranchAddress(branch?.address)
                                 }))?.filter(branch => !!branch?.name)}/>
                }


                <div className={formClasses.FormItem + ' ' + formClasses.FormRow}>
                  <Accordion defaultExpanded={!!Object.keys(formActions.values.receiverAddress || {}).length}
                             elevation={2}
                             className={formClasses.FormAccordion}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon/>}
                      className={classes.AddressCollapseWrapper}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <div className={classes.ReceiverAddressWrapper}>
                        {!!Object.keys(formActions.values.receiverAddress || {}).length ?
                          <div className={formClasses.FormItem + ' info ' + formClasses.FormRow}>
                            <InputLabel><FormattedMessage id={'Fields.label.Address'}/>{!!inDialog &&
                            <span className={'required'}>*</span>}:</InputLabel>
                            <div className={'info-data'}>
                              <strong>{receiverAddressCombined}</strong>
                            </div>
                          </div>
                          : <Typography className={classes.ItemHeading}><FormattedMessage
                            id={'Fields.label.Address'}/>{!!inDialog &&
                          <span className={'required'}>*</span>}</Typography>
                        }
                        <div>
                          <IconButton color="secondary" aria-label="Edit"
                                      disabled={'B' === formActions.values.receiverType && !!currentReceiverDetailsFailure}
                                      onClick={(e) => handleAddressDialog(e, 'Receiver')}>
                            <EditIcon/>
                          </IconButton>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className={formClasses.AddressInfoWrapper}>
                        {Object.keys(formActions.values.receiverAddress || {})?.map((column, index) => (
                          !!formActions.values.receiverAddress[column]?.trim() && !['country'].includes(column) &&
                          <div key={index} className={formClasses.FormItem + ' info '}>
                            <InputLabel><FormattedMessage id={`Issuer.Address.${column}`}/></InputLabel>
                            <div className={'info-data'}>
                              <strong>{formActions.values.receiverAddress[column]}</strong>
                            </div>
                          </div>
                        ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  {formActions.errors.receiverAddress && formActions.touched.receiverAddress && (
                    <FormHelperText error={true}><FormattedMessage
                      id='validationSchema.address.required'/></FormHelperText>
                  )}
                </div>
              </div>
            </AccordionDetails>
          )}
        </CreateInvoiceConsumer>
      </Accordion>
    </div>
  )
}

export default Receiver
